namespace Core {

    export interface ICustomPopupOptions {
        popupContainer?: string;
        popupScope: Object;
    }

    interface IDefaultPopupOptions {
        popupContainer: string;
    }

    export interface IPopupScope extends ng.IScope {
        showPopup: boolean;
        confirm: (val?: any) => void;
        close: (val?: any) => void;
        cancel: (val?: any) => void;
        [key: string]: any;
    }

    export class BasePopupService {
        private defaultOptions: IDefaultPopupOptions;

        constructor(
            private $compile: ng.ICompileService,
            private $q: ng.IQService,
            private $rootScope: ng.IRootScopeService,
            private $timeout: ng.ITimeoutService
        ) {
            this.defaultOptions = {
                popupContainer: 'body'
            };
        }

        public showPopup(template: string, popupOptions: ICustomPopupOptions): ng.IPromise<any> {
            const defer = this.$q.defer();
            const options = Object.assign(this.defaultOptions, popupOptions);
            let scope = this._createScope(defer, options.popupScope || {});

            const compiledElement = this.$compile(template)(scope);
            const container = angular.element(options.popupContainer);
            this.addPopupToContainer(container, compiledElement);
            return defer.promise.then((val) => {
                    sessionStorage.setItem('PopUpConfirmed', 'true');
                    scope.showPopup = false;
                    this.removePopupFromContainer(compiledElement);
                    return this.$q.when(val);
                },
                (val) => {
                    sessionStorage.removeItem('PopUpConfirmed');
                    scope.showPopup = false;
                    this.removePopupFromContainer(compiledElement);
                    return this.$q.reject(val);
                });
        }

        public addPopupToContainer(container, template: any) {
            return container.append(template);
        }

        public removePopupFromContainer(element) {
            setTimeout(() => {
                element.remove();
                this.$rootScope.$apply();
            });
        }

        private _createScope(defer: ng.IDeferred<any>, customScope: Object, ): IPopupScope {
            const sc = this.$rootScope.$new();
            const mergedScope = Object.assign(sc, {
                defer,
                showPopup: true,
                close(value?) {
                    defer.reject({
                        result: 'close',
                        value
                    });
                },
                confirm(value?) {
                    defer.resolve({
                        result: 'confirm',
                        value
                    });
                },
                cancel(value?) {
                    defer.reject({
                        result: 'cancel',
                        value
                    });
                },
                ...customScope
            });
            _.functions(mergedScope).forEach((f) => {
                mergedScope[f] = mergedScope[f].bind(mergedScope);
            });
            return mergedScope;
        }
    }

    angular.module('TR').service('basePopupService', BasePopupService);
}
